export const PURCHASE_TIP_TEXTS = {
  auction: {
    approval: {
      description:
        'Approve the auction smart contract to use a specified amount of your tokens. This step grants permission without transferring funds yet.',
      mobile:
        'Before proceeding, <strong class="dark:text-default-50">please confirm </strong> the transaction in your <strong class="dark:text-default-50">mobile crypto wallet.</strong>',
      desktop:
        'Before proceeding, <strong class="dark:text-default-50">please confirm </strong> the transaction in your <strong class="dark:text-default-50">crypto wallet extension.</strong>',
    },
    pending: {
      description:
        'After approval, your bid amount is automatically transferred to the auction smart contract, confirming your participation in the auction.',
      mobile:
        '<strong class="dark:text-default-50">Please confirm</strong> one final transaction in your <strong class="dark:text-default-50">mobile crypto wallet.</strong>',
      desktop:
        '<strong class="dark:text-default-50">Please confirm</strong> one final transaction in your <strong class="dark:text-default-50">crypto wallet extension.</strong>',
    },
  },
  purchase: {
    approval: {
      description:
        'Approve the purchase smart contract to use a specified amount of your tokens. This step grants permission without transferring funds yet.',
      mobile:
        'Before proceeding, <strong class="dark:text-default-50">please confirm </strong> the transaction in your <strong class="dark:text-default-50">mobile crypto wallet.</strong>',
      desktop:
        '<strong class="dark:text-default-50">Please confirm</strong> one final transaction in your <strong class="dark:text-default-50">crypto wallet extension.</strong>',
    },
    pending: {
      description:
        'After approval, your payment amount is automatically transferred to the purchase smart contract, finalizing your acquisition of the artwork.',
      mobile:
        '<strong class="dark:text-default-50">Please confirm</strong> one final transaction in your <strong class="dark:text-default-50">mobile crypto wallet.</strong>',
      desktop:
        '<strong class="dark:text-default-50">Please confirm</strong> one final transaction in your <strong class="dark:text-default-50">crypto wallet extension.</strong>',
    },
  },
} as const;

export const PURCHASE_STEPS_TEXTS = {
  auction: {
    first: 'Approval request',
    second: 'Bid submission',
  },
  purchase: {
    first: 'Approval request',
    second: 'Purchase confirmation',
  },
} as const;
